<script setup lang="ts">
import MainLayout from "views/layouts/MainLayout.vue";
import { computed, onMounted, ref, watch } from 'vue';
import translaters from '../../tradutors/assine';
import { localeStore } from '../../stores/locale';
import { planStore } from '../../stores/plans';
import { userStore } from "../../stores/user";
import { useHead } from '@unhead/vue';
import { useRoute } from 'vue-router';
import { isMobile } from "../shared/utils/mobile";
import router from '../../router'
import AssinePlansChoice from "components/Assine/AssinePlansChoice.vue";
import AssineBoleto from "components/Assine/AssineBoleto.vue";
import AssinePix from "components/Assine/AssinePix.vue";
import AssineTransferItau from "components/Assine/AssineTransferItau.vue";
import AssineCreditCard from "components/Assine/AssineCreditCard.vue";
import FormPaymentUnavailable from "components/Assine/FormPaymentUnavailable.vue";
import PdfComponent from "components/PdfComponent.vue";
import { assineChoiceStore } from '../../stores/assineChoice'

const storeLocale = localeStore()
const storePlan = planStore()
const storeUser = userStore()
const storeAssineChoice = assineChoiceStore()
const route = useRoute()

const formComponent = ref(null)
const flexRadioCheckout = ref(null)
const urlPdf = ref(null)
const reactiveLocale = computed(() => storeLocale.locale) // Certifique-se de que locale é uma ref
const reactiveVoucher = computed(() => storePlan.voucher)
const reactiveCoupon = computed(() => storePlan.coupon)
const reactiveIsActiveUser = computed(() => storeUser.isActiveUser)
const reactiveIsLoggedIn = computed(() => storeUser.isLoggedIn)
const reactiveCardOnlyPromotion = computed(() => storePlan.cardOnlyPromotion)
const reactiveAssineChoice = computed(() => storeAssineChoice)
const reactivePlans = computed(() => storePlan.plans) 

const titles = computed(function () {
    if (reactiveLocale.value === "pt-br") {
        return [
          "Cartão de Crédito",
          "Transferência Eletrônica ITAÚ",
          "PIX",
          "Boleto Bancário",
        ];
      } else {
        return ["Credit Card"];
      }
}) 

const translate = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return translaters.portugues
    } else {
      return translaters.ingles
    }
})

watch(flexRadioCheckout, (val:number) => {
    urlPdf.value = '';
    Array.from(document.getElementsByClassName("title-radio")).forEach(
        (element: HTMLElement) => {
            element.style.color = '#ACACAC';
        }
    );
    document.getElementById('titleRadio'+val).style.color = "#000";

    Array.from(document.getElementsByClassName("options-mobile")).forEach(
        (element: HTMLElement) => {
            element.classList.remove('options-mobile-checked');
        }
    );
    if (document.getElementById('titleRadioMobile'+val)) {        
        document.getElementById('titleRadioMobile'+val).classList.add('options-mobile-checked');
    }
    if ( val != 0 && (reactiveVoucher.value || (reactiveCoupon.value && reactiveCardOnlyPromotion.value)) && !reactiveIsActiveUser.value ) {
        formComponent.value = FormPaymentUnavailable
        return false;
    }    
    switch (val) {
        case 0:
            formComponent.value = AssineCreditCard
        break
        case 1:
            formComponent.value = AssineTransferItau                
        break
        case 2:
            formComponent.value = AssinePix
        break
        case 3:
            formComponent.value = AssineBoleto
        break
        default:
            formComponent.value = AssineCreditCard
        break
    }
})

watch(reactivePlans, () => {
    sessionStorage.removeItem('assineChoice')    
    redirect('AssineOptionsPage')
})

onMounted(() => {
    flexRadioCheckout.value = 0
})

useHead({
    templateParams: {
    subTitle: null, 
        subPage: reactiveLocale.value == 'pt-br' ? 'Assine' : 'Subscribe Now',
        page_url: window.location.origin + route.fullPath,
        page_description:
        reactiveLocale.value == 'pt-br'
            ? `Quer ver tudo sem censura? Assine agora e tenha acesso ao conteúdo VIP`
            : `Want to see everything uncensored? Subscribe now and get access to VIP content`,
        page_image: '/favicon.ico',
        page_keywords:
        'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
        page_locale: reactiveLocale.value,
        page_url_pt: 'https://belladasemana.com.br/pt-br/assine',
        page_url_en: 'https://belladasemana.com.br/en/assine',
        page_canonical: 'https://belladasemana.com.br' + route.fullPath
    }
})

function clickMobile(val) {
    flexRadioCheckout.value = val
}

function redirect(name) {
    router.push({
        name,
        params: {
            locale: reactiveLocale.value
        }
    })
}

function showPdfBoleto(value: string) {
    urlPdf.value = value;
}

</script>

<template>
    <MainLayout #="{ showModalMessages }">
        <div class="slot-body">    
            <div class="container">
                <div class="col-lg-8 col-12 checkout-header d-flex">
                    <div class="breadcrumb breadcrumb1" @click="redirect('AssineOptionsPage')">{{ translate.breadcrumb1 }}</div>
                    <div class="breadcrumb">></div>
                    <div class="breadcrumb breadcrumb1" @click="redirect('AssineAccountPage')">{{ isMobile() ? translate.breadcrumbMobile2 : translate.breadcrumb2 }}</div>
                    <div class="breadcrumb">></div>
                    <div class="breadcrumb breadcrumb2">{{ isMobile() ? translate.breadcrumbMobile3 : translate.breadcrumb3 }}</div>
                    <div class="breadcrumb">></div>                
                    <div class="breadcrumb">{{ translate.breadcrumb4 }}</div>
                </div>
            </div>
            <div class="container pb-3" v-if="reactiveIsLoggedIn && reactiveAssineChoice.choiceId">
                <div class="col-lg-8 col-12 checkout-col">
                    <AssinePlansChoice />
                </div>
                <div class="col-lg-8 col-12 checkout-col">
                    <div class="col-12 pt-3 pb-2">
                        <div class="resume-title">{{ translate.titleFormCheckout }}</div>
                        <div class="resume-line"></div>
                    </div>   
                    <div class="title-options pt-3 pb-2">{{ translate.PlansSubTitle }}</div>
                    <div class="d-flex" v-if="!isMobile()">
                        <div v-for="(title, index) in titles" :key="index">
                            <input class="form-check-input" :value="index" type="radio" v-model="flexRadioCheckout" name="flexRadioCheckout" id="flexRadioCheckout" /> 
                            <span class="title-radio ps-2 pe-5" :id="`titleRadio${index}`">{{ title }}</span>
                        </div>
                    </div>
                    <div class="" v-else>
                        <div v-for="(title, index) in titles" :key="index" 
                            :id="`titleRadioMobile${index}`" 
                            class="d-flex options-mobile ps-3 mb-2"
                            @click="clickMobile(index)">
                            <input class="form-check-input-mobile align-self-center" :value="index" type="radio" v-model="flexRadioCheckout" name="flexRadioCheckout" id="flexRadioCheckout" /> 
                            <span class="title-radio-mobile ps-2 pe-5 align-self-center" :id="`titleRadio${index}`">{{ title }}</span>
                        </div>
                    </div>
                    <div class="footer-options" v-if="!isMobile()">{{ translate.footerOptionsCheckout }}</div>                    
                    <div class="pt-4 form-component">
                        <component
                            :is="formComponent"
                            @showBoleto="showPdfBoleto"
                            @showModalMessages="showModalMessages"
                        ></component>
                        <PdfComponent v-if="urlPdf" :url="urlPdf" />                        
                    </div>
                </div>
            </div>
            <div class="col-lg-8 col-12 checkout-col py-3" v-else>
                {{ translate.checkPlanAndLogin }}
            </div>
        </div>
    </MainLayout>    
</template>

<style scoped lang="css">
.slot-body {
    margin-top: 65px !important;    
    background-color: #fff;    
}
.breadcrumb {
    padding: 20px 5px;
    font-family: 'Exo-2';
    font-weight: 400;
    font-size: 14px;
    line-height: 16.8px;
    color: #979797;    
    margin-bottom: unset;    
}

.breadcrumb1 {
    color: #5B5858;    
    cursor: pointer;
}

.breadcrumb1:hover {
    text-decoration:underline;
}

.breadcrumb2 {
    color: #5B5858;    
}

.checkout-col {
    margin-left: 50%;
    transform: translate(-50%);
}

.checkout-header{
    margin-left: 50%;
    transform: translate(-50%);
}

.form-check-input:checked[type='radio'] {
    --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%232FBD6A'/%3e%3c/svg%3e");
}

.title-radio {
    cursor: default;
}

.form-check-input:checked {
    background-color: #ffffff;
    border-color: #2FBD6A;
}

.form-check-input {
    --bs-form-check-bg: #fff;
    width: 16px;
    height: 16px;
    border: 2px solid #ACACAC;
    cursor: pointer;
}

.form-check-input-mobile:checked[type='radio'] {
    --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23006FCF'/%3e%3c/svg%3e");
}

.form-check-input-mobile:checked {
    background-color: #ffffff;
    border-color: #006FCF;
}

.form-check-input-mobile {
    --bs-form-check-bg: #fff;
    width: 16px;
    height: 16px;
}


.resume-title {
    font-family: 'Exo-2';
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #4B4B4B;
    padding-bottom: 10px;
    padding-top: 20px;
}

.resume-line {
    border: 1px solid #DEDEDE;
}

.title-options {
    font-family: 'Exo-2';
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #4B4B4B;
}

.title-radio {
    font-family: 'Exo-2';
    font-weight: 500;
    font-size: 17px;
    line-height: 22px;
    color: #ACACAC;
}

.title-radio-mobile {
    font-family: 'Exo-2';
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.footer-options {
    font-family: 'Roboto-Regular';
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #ACACAC;
    margin-top: 5px;
}

.vcpg {
  border: none !important;
}

.vcpg :deep(.vcp__header) {
  border-radius: 10px;
  background-color: #F5F5F5 !important;
  margin-top: 10px;
  padding: 26px;
  border: 1px solid var(--border-color);
}

.title-terms {
    font-family: 'Exo-2';
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #0B0B0B;
}

.acept-text {
    font-family: 'Exo-2';
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    color: #4B4B4B;
}

input[type=checkbox]:before {
    content: "";
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    top: -3px;
    left: -3px;
    background-color: unset; 
}

.options-mobile {
    height: 50px;
    background-color: #F5F5F5;
    border: 1px solid #DEDEDE;
    border-radius: 5px;
}

.options-mobile-checked {
    height: 50px;
    background-color: #EFF5FF;
    border: 1px solid #1773B0;
    border-radius: 5px;
}
/* regras mobile 769px */
@media screen and (max-width: 769px) {
   
    .checkout-col {
        margin-left: 50%;
        transform: translate(-50%);
        padding-top: 30px;
    }   
    
    .form-component {
        background-color: #F5F5F5;
        border-radius: 10px;
        border: 1px solid #D9D9D9;
        padding: 10px;
    }
}
</style>